import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Box,
    Typography,
    Button,
    FormControl,
    FormLabel,
    FormGroup, 
    Grid,
    Alert
} from '@mui/material';
import React, { useState, useEffect } from 'react';
import QRCode from 'qrcode';
import API from '../services/api';

const QRPassDisplayDialog = ({
  customer,
  qrCode,
  checkIn = true,
  open,
  onClose,
  mode = 'view'
}) => {

  
  const [displayQrCode, setDisplayQrCode] = useState(qrCode);
  const [checkInOnCreate, setCheckInOnCreate] = useState(checkIn);
  const [currentMode, setCurrentMode] = useState(mode);
  const [isDisplaying, setIsDisplaying] = useState(false);
  const [qrImage, setQrImage] = useState('');
  const [error, setError] = useState(null);

  useEffect(() => {
    QRCode.toDataURL(displayQrCode?.qrCode)
      .then((dataURL) => {
        setQrImage(dataURL);
      })
      .catch((error) => {
        console.error('Error generation QR-code:', error);
      });
  }, [currentMode, displayQrCode?.qrCode]);


  const handleDisplayClick = () => {
    const action = isDisplaying ? 'hide' : 'display';
      API.post('/api/display/qr', {
        action: action,
        qrCodeId: displayQrCode.id
      }).then(() => {
        setIsDisplaying(!isDisplaying);
      })
      .catch(error => {
        if (error.response && error.response.data && error.response.data.msg) {
          setError(error.response.data.msg);
        } else {
          setError(error.message);
        }
        console.error('Error when creating customer:', error)
      });
  }

  const sanitizeFilename = (filename) => {
    // Replace spaces to '-'
    let sanitized = filename.replace(/\s+/g, '-');
    // Leave only letters, digits, '-', '_', '.'
    sanitized = sanitized.replace(/[^a-zA-Z0-9\-\._]/g, '');
    // Remove '-' and '.' in the beginning and end
    sanitized = sanitized.replace(/^[\-\.]+|[\-\.]+$/g, '');
    // if string is empty after than just use word 'customer'
    return sanitized || 'customer';
  };


  const handleDownloadQR = async () => {
  if (!displayQrCode?.qrCode) return;

  try {
    // Generate high-resolution QR code for download
    const dataURL = await QRCode.toDataURL(displayQrCode.qrCode, {
      width: 500,
      height: 500
    });

    const safeCustomerName = sanitizeFilename(customer.name);
    const filename = `qr-pass-${safeCustomerName}.png`;

    // Create temporary link
    const link = document.createElement('a');
    link.href = dataURL;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    console.error('Error generating high-resolution QR code:', error);
    setError('Failed to generate high-resolution QR code');
  }
};

const handlePaidClick = async () => {
  try {
    const params = new URLSearchParams();
    params.append('checkIn', checkInOnCreate);
    const response = await API.post(
      `/api/customers/${customer.id}/passes?${params.toString()}`,
      displayQrCode
    );
    setDisplayQrCode(response.data);
    setCurrentMode('view');
  } catch (error) {
    if (error.response && error.response.data && error.response.data.msg) {
      setError(error.response.data.msg);
    } else {
      setError(error.message);
    }
    console.error('Error creating QR Code:', error);
  }
};

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>QR Pass</DialogTitle>
      <DialogContent>
        {error && <Alert severity="error">{error}</Alert>}
        <Box sx={{
                    display: 'flex',
                    flexDirection: 'row',
                     gap: '20px'
                }}>
          <Box>
            {qrImage && <img src={qrImage} alt="QR Code" />}
          </Box>
          <Box sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '5px',
                    padding: '0px',
                }}>
          <FormControl component="fieldset" >
            <FormLabel component="legend">
                QR Pass
            </FormLabel>
            <FormGroup>
              <Grid container columnSpacing={1}>
                  <Grid container item xs={6} direction="column">
                    <Grid item xs={6}>
                      <Typography variant="body1">Start Date:</Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography variant="body1">Expire Date:</Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography variant="body1">Amount:</Typography>
                    </Grid>
                  </Grid>
                  <Grid container item xs={6} direction="column">
                    <Grid item xs={6}>
                      <Typography variant="body1">{displayQrCode.startDate.split('T')[0]}</Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography variant="body1">{displayQrCode.endDate.split('T')[0]}</Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography variant="body1">{displayQrCode.amount}</Typography>
                    </Grid>
                  </Grid>
                </Grid>
            </FormGroup>
          </FormControl>
          <FormControl component="fieldset" >
            <FormLabel component="legend">
                Customer
            </FormLabel>
            <FormGroup>
                <Grid container columnSpacing={1}>
                  <Grid container item xs={6} direction="column">
                    <Grid item xs={6}>
                      <Typography variant="body1">Name:</Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography variant="body1">Phone:</Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography variant="body1">Email:</Typography>
                    </Grid>
                  </Grid>
                  <Grid container item xs={6} direction="column">
                    <Grid item xs={6}>
                      <Typography variant="body1">{customer.name}</Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography variant="body1">{customer.phone}</Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography variant="body1">{customer.email}</Typography>
                    </Grid>
                  </Grid>
                </Grid>
            </FormGroup>
          </FormControl>
        </Box>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onClose(displayQrCode)}>Close</Button>

        {currentMode === 'create' && (
          <Button
            variant="contained"
            color="success"
            onClick={handlePaidClick}
            sx={{ ml: 'auto' }}
          >
            Paid
          </Button>
        )}

        {currentMode === 'view' && (
          <>
            <Button
              variant={isDisplaying ? 'contained' : 'outlined'}
              onClick={handleDisplayClick}
            >
              {isDisplaying ? 'Displaying' : 'Display'}
            </Button>
            <Button
              variant="outlined"
              color="primary"
              onClick={handleDownloadQR}
            >
              Download
            </Button>
          </>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default QRPassDisplayDialog;
